import { render } from "./modalWrapper.vue?vue&type=template&id=1f7a0374&scoped=true&ts=true"
import script from "./modalWrapper.vue?vue&type=script&lang=ts"
export * from "./modalWrapper.vue?vue&type=script&lang=ts"

import "./modalWrapper.vue?vue&type=style&index=0&id=1f7a0374&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f7a0374"]])

export default __exports__